export default __webpack_public_path__ + "static/media/goopter-kiosk-mockup.5849413b.jpg";